import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-field-boolean",
  "use": "icon-field-boolean-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" class=\"euiIcon euiIcon--medium euiIcon-isLoaded\" role=\"img\" aria-label=\"Boolean field\" id=\"icon-field-boolean\">\n    <title>Boolean field</title>\n    <path fill-rule=\"evenodd\" d=\"M8 13A5 5 0 118 3a5 5 0 010 10zm-2.828-2.172a4 4 0 015.656-5.656c.004.013-5.645 5.674-5.656 5.656z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol